export const employmentStatusUntilRulesOptions = {
  required: 'EmploymentStatusUntil.error.required',
};
